export default __webpack_public_path__ + "static/media/gallery_05.0e0ba6f1.jpg";